// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/site/img/check-white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.checkout-block {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 40px;
}

.checkout-block__title {
    margin-bottom: 20px;
}

.checkout-personal {

}

.checkout-personal__item {
    display: block;
    margin-bottom: 20px;
}

.checkout-personal__title {
    margin-bottom: 5px;
}

.checkout-personal__input {

}

.checkout-error {
    color: #dd0000;
    visibility: hidden;
    display: block;
    font-weight: bold;
}

.checkout-error:before {
    content: '\\a0';
}

.checkout-textarea{
    box-sizing: border-box;
    display: block;
    height:150px;
}

.checkout-block {

}

.checkout-block__title.error .checkout-error,
.checkout-personal__input.error + .checkout-error {
    visibility: visible;
}

.checkout-block-item {
    border: 2px solid var(--color-periwinkle-crayola);
    margin-bottom: 20px;
    padding: 15px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
}

.checkout-block-item__title {

}

.checkout-block-item__content {

}

.checkout-block-item.active {
    border: 2px solid var(--color-granite);
    /*background-color: #f0f0f0;*/
    /*transform: scale(1.1);*/
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.2);
}

.checkout-block-item.active:before {
    position: absolute;
    width: 24px;
    height: 24px;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-color: var(--color-granite);
    border-radius: 12px;
    top: -12px;
    left: -12px;
    text-align: center;
}

.checkout-payment_item-item.inactive {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: stretch;
}

.checkout-block-products {
}

.checkout-block-product {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    gap: 15px;
    margin-bottom:10px;
}

.checkout-block-product__photo {
    flex: 0 0 70px;
    aspect-ratio: auto;
}

.checkout-block-product__img {
    width: 100%;
    height: auto;
    object-fit: cover;
}

.checkout-block-product__info {
    flex: 1 1 auto;
    gap: 5px;
    color: var(--color-granite);
    text-transform: uppercase;
}

.checkout-block-product__name {
    font-size: var(--font-s);
    font-weight: 700;
}

.checkout-block-product__parameter {
    font-size: var(--font-xs);
    font-weight: normal;
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
}

.checkout-block-product__article {
    font-size: var(--font-xs);
    font-weight: normal;
}

.checkout-block-product__color {
    font-size: var(--font-xs);
    font-weight: normal;
}

.checkout-block-product__count{
    font-size: var(--font-xs);
    font-weight: normal;
}
.checkout-block-product__price {
    font-size: var(--font-s);
    font-weight: 700;
}

.checkout-block-product__discount {
    color: var(--color-gray-window);
    text-decoration: line-through;
}

.checkout-submit {
    background-color: var(--color-light-periwinkle-crayola);
    padding: 20px;
    text-align: center;
    width: 600px;
    max-width: 100%;
}

.checkout-submit-line {
    display: flex;
    justify-content: space-between;
    font-size: var(--font-m);
    align-items: center;
    outline: none !important;
}

.checkout-submit-line__title {
    font-size: var(--font-m);
    outline: none !important;
    text-decoration: none;
}

.checkout-submit-line__value {
    outline: none !important;
    text-decoration: none;
}

.checkout-submit-button {
    text-align: center;
    padding: 30px 0;
}

.checkout-submit-info {
}

.checkout-errors{
    color:#dd0000 !important;
    padding: 20px 0;
}
.checkout-errors .checkout-submit-line__value{
    text-decoration: underline !important;
    color:#dd0000 !important;
}
@media screen and (max-width: 1024px) {

}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/checkout/main.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;;AAEA;;AAEA;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gDAAyD;IACzD,sCAAsC;IACtC,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;AACA;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,uDAAuD;IACvD,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;AACA;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,qCAAqC;IACrC,wBAAwB;AAC5B;AACA;;AAEA","sourcesContent":["\n.checkout-block {\n    width: 100%;\n    max-width: 600px;\n    margin: 0 auto;\n    margin-top: 40px;\n    margin-bottom: 40px;\n}\n\n.checkout-block__title {\n    margin-bottom: 20px;\n}\n\n.checkout-personal {\n\n}\n\n.checkout-personal__item {\n    display: block;\n    margin-bottom: 20px;\n}\n\n.checkout-personal__title {\n    margin-bottom: 5px;\n}\n\n.checkout-personal__input {\n\n}\n\n.checkout-error {\n    color: #dd0000;\n    visibility: hidden;\n    display: block;\n    font-weight: bold;\n}\n\n.checkout-error:before {\n    content: '\\a0';\n}\n\n.checkout-textarea{\n    box-sizing: border-box;\n    display: block;\n    height:150px;\n}\n\n.checkout-block {\n\n}\n\n.checkout-block__title.error .checkout-error,\n.checkout-personal__input.error + .checkout-error {\n    visibility: visible;\n}\n\n.checkout-block-item {\n    border: 2px solid var(--color-periwinkle-crayola);\n    margin-bottom: 20px;\n    padding: 15px;\n    border-radius: 6px;\n    cursor: pointer;\n    position: relative;\n}\n\n.checkout-block-item__title {\n\n}\n\n.checkout-block-item__content {\n\n}\n\n.checkout-block-item.active {\n    border: 2px solid var(--color-granite);\n    /*background-color: #f0f0f0;*/\n    /*transform: scale(1.1);*/\n    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.2);\n}\n\n.checkout-block-item.active:before {\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    content: url(../../../../assets/site/img/check-white.svg);\n    background-color: var(--color-granite);\n    border-radius: 12px;\n    top: -12px;\n    left: -12px;\n    text-align: center;\n}\n\n.checkout-payment_item-item.inactive {\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: stretch;\n}\n\n.checkout-block-products {\n}\n\n.checkout-block-product {\n    display: flex;\n    flex-direction: row;\n    justify-content: stretch;\n    gap: 15px;\n    margin-bottom:10px;\n}\n\n.checkout-block-product__photo {\n    flex: 0 0 70px;\n    aspect-ratio: auto;\n}\n\n.checkout-block-product__img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n}\n\n.checkout-block-product__info {\n    flex: 1 1 auto;\n    gap: 5px;\n    color: var(--color-granite);\n    text-transform: uppercase;\n}\n\n.checkout-block-product__name {\n    font-size: var(--font-s);\n    font-weight: 700;\n}\n\n.checkout-block-product__parameter {\n    font-size: var(--font-xs);\n    font-weight: normal;\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    flex-wrap: wrap;\n}\n\n.checkout-block-product__article {\n    font-size: var(--font-xs);\n    font-weight: normal;\n}\n\n.checkout-block-product__color {\n    font-size: var(--font-xs);\n    font-weight: normal;\n}\n\n.checkout-block-product__count{\n    font-size: var(--font-xs);\n    font-weight: normal;\n}\n.checkout-block-product__price {\n    font-size: var(--font-s);\n    font-weight: 700;\n}\n\n.checkout-block-product__discount {\n    color: var(--color-gray-window);\n    text-decoration: line-through;\n}\n\n.checkout-submit {\n    background-color: var(--color-light-periwinkle-crayola);\n    padding: 20px;\n    text-align: center;\n    width: 600px;\n    max-width: 100%;\n}\n\n.checkout-submit-line {\n    display: flex;\n    justify-content: space-between;\n    font-size: var(--font-m);\n    align-items: center;\n    outline: none !important;\n}\n\n.checkout-submit-line__title {\n    font-size: var(--font-m);\n    outline: none !important;\n    text-decoration: none;\n}\n\n.checkout-submit-line__value {\n    outline: none !important;\n    text-decoration: none;\n}\n\n.checkout-submit-button {\n    text-align: center;\n    padding: 30px 0;\n}\n\n.checkout-submit-info {\n}\n\n.checkout-errors{\n    color:#dd0000 !important;\n    padding: 20px 0;\n}\n.checkout-errors .checkout-submit-line__value{\n    text-decoration: underline !important;\n    color:#dd0000 !important;\n}\n@media screen and (max-width: 1024px) {\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
